// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2AYq8","label":"Completed_label__2Ko3x"};